// extracted by mini-css-extract-plugin
export default {"wrapper":"aFefK0","clickableArea":"Iv3v_S","dropdown":"UrCW_p","arrowUp":"dDQqA3"};